// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc8fffa2","726":"8949fc63"}[chunkId] + ".chunk.js";
};